
let menuClone = document.querySelector('ul.menu').cloneNode(true);
document.getElementById('mobileMenu').appendChild(menuClone);

document.querySelector('a.menu-link').addEventListener('click', function(event) {
	event.preventDefault();
	document.querySelector('body').classList.toggle('panelOpen');
});
